import { parrotApi } from '@libs/openapi';
import { isEqual } from 'lodash-es';
import { useEffect, useState } from 'react';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';
import { useAddress } from './use-address';
import { useRefreshTime } from './use-refresh';

export const useVaultsMine = (
  query: Omit<OpenapiClientParrotVault.GetVaultVaultsMineQuery, 'owner'>,
) => {
  const { refreshTime } = useRefreshTime();
  const address = useAddress();

  const [vaultsMine, setVaultsMine] =
    useState<OpenapiClientParrotVault.GetVaultVaultsMineResponse>();
  const [pre, setPre] = useState<Omit<OpenapiClientParrotVault.GetVaultVaultsMineQuery, 'owner'>>();

  const getVaultsMine = async () => {
    if (!address) {
      setVaultsMine(undefined);
      return;
    }

    if (!isEqual(query, pre)) {
      setVaultsMine(undefined);
    }

    const result = await parrotApi.get('/vault/vaults/mine', {
      query: {
        owner: address,
        ...query,
        page: 1,
        limit: 100,
      },
    });
    setVaultsMine(result);
    setPre(query);
  };

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    const loop = () => {
      getVaultsMine();
      timer = setTimeout(() => {
        loop();
      }, 60 * 1000);
    };
    loop();
    return () => {
      clearTimeout(timer);
    };
  }, [query.direction, query.sort, address, query.protocol, refreshTime]);

  return {
    vaultsMine,
  };
};
